import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MultiAppsComponent} from "./multi-apps.component";

const routes: Routes = [
  {
    path: '',
    component: MultiAppsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MultiAppsRoutingModule {
}
